module.exports = __webpack_public_path__ + "img/icon-bad.cc548357.png";